// When the customer pays what is left after the booking advance: 25% of the total package amount
// right after boarding the vehicle (rounded up to the next INR 100), and the rest on Day 1 after
// hotel check-in. Mirrors BookingPaymentSchedule on the backend - keep the two in step.
//
// Only bookings that recorded their advance at creation (bookingAdvanceAmount) have a schedule;
// older bookings keep the single "balance by Day 1" terms they were sold on.

export function paymentSchedule(total, advance, paid) {
  const totalAmount = nonNegative(total);
  if (!totalAmount) return null;
  const advanceAmount = Math.min(nonNegative(advance), totalAmount);
  const afterAdvance = totalAmount - advanceAmount;
  const quarter = Math.ceil((totalAmount * 25) / 10000) * 100;
  // Never more than what is left after the advance, so the Day 1 amount cannot go negative.
  const afterBoardingAmount = Math.min(quarter, afterAdvance);
  const dayOneAmount = afterAdvance - afterBoardingAmount;

  const paidAmount = nonNegative(paid);
  const balanceDue = Math.max(0, totalAmount - paidAmount);
  // Payments count towards the stages in order: advance, then after boarding, then Day 1.
  const afterBoardingDue = Math.min(afterBoardingAmount, Math.max(0, advanceAmount + afterBoardingAmount - paidAmount));
  const dayOneDue = Math.max(0, balanceDue - afterBoardingDue);
  return { totalAmount, advanceAmount, afterBoardingAmount, dayOneAmount, paidAmount, afterBoardingDue, dayOneDue, balanceDue };
}

/** The schedule for a saved booking, or null when it predates the schedule. */
export function bookingPaymentSchedule(booking, total) {
  if (booking?.bookingAdvanceAmount == null || booking.bookingAdvanceAmount === "") return null;
  return paymentSchedule(total, booking.bookingAdvanceAmount, booking.advancePaid);
}

/** "INR 6,500" / "INR 6,500 (Paid)" / "INR 6,500 (INR 3,000 due)" for documents and tables. */
export function scheduleStageText(amount, due, currency = "INR ") {
  const money = (value) => `${currency}${Number(value || 0).toLocaleString("en-IN")}`;
  if (!amount) return money(0);
  if (!due) return `${money(amount)} (Paid)`;
  if (due < amount) return `${money(amount)} (${money(due)} due)`;
  return money(amount);
}

function nonNegative(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
}
